module.exports = __webpack_public_path__ + "img/zhAward-5.3db94c53.png";